import MainContentWrapper from './MainContentWrapper'
export default MainContentWrapper